import { render } from "./Question.vue?vue&type=template&id=1f4a1672&scoped=true&ts=true&lang=pug"
import script from "./Question.vue?vue&type=script&lang=ts"
export * from "./Question.vue?vue&type=script&lang=ts"

import "./Question.vue?vue&type=style&index=0&id=1f4a1672&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4a1672"]])

export default __exports__